import { SITE } from '@/app/constants';

const URL =
  SITE === 'china'
    ? 'https://image01-aliyun.vidu.zone/vidu/media-asset/bg-34b53111.webp'
    : 'https://image01.cf.vidu.studio/vidu/media-asset/bg-34b53111.webp';

export function DecorBackground() {
  return (
    <div className="pointer-events-none absolute inset-x-0 top-0 h-[520px] overflow-hidden">
      <img src={URL} alt="" aria-hidden="true" className="size-full object-cover" />
      <div className="absolute inset-x-0 bottom-0 h-52 bg-gradient-to-b from-transparent via-[#05060a]/70 to-[#05060a]" />
    </div>
  );
}
